import React, { Component } from 'react'

import { Dialog, DialogContent, DialogTitle, DialogActions, Button } from '@material-ui/core'
import ImageUploaderModal from '../../common/ImageUploaderModal'
import { getSession } from '../../../utils/api'
import { openErrorMessage, openSuccessMessage } from '../../../actions/message'
import { TemplateProducts } from '../../../assets'
import { uploadCsv } from '../../../actions/assets'
import { getReportApiUrl } from '../../../utils/common'

const reportApi = getReportApiUrl()

class ModalMcImportProducts extends Component {
  constructor(props) {
    super(props)

    this.state = {
      file: null,
      hasError: false,
    }
  }

  onUpload = (file) => {
    this.setState({
      file,
      hasError: !file,
    })
  }

  onError = (error) => {
    this.props.dispatch(openErrorMessage(error))
  }

  downloadTemplate = () => {
    window.open(TemplateProducts)
  }

  exportProducts = () => {
    const user = getSession()
    window.open(
      `${reportApi}api/v1/mgmt/export/master-products?assetToken=${encodeURIComponent(
        user.assetAccessToken,
      )}`,
    )
  }

  processUploadDocument = () => {
    const { file } = this.state

    if (!file) {
      this.setState({ hasError: true })
      return
    }

    if (file) {
      this.props.dispatch(uploadCsv(file)).then((photo) => {
        this.props.closeModal()
        this.props.dispatch(openSuccessMessage('Process started, this may take a few minutes'))
      })
    }
  }

  render() {
    const { open } = this.props
    const { file, hasError } = this.state

    return (
      <Dialog open={open}>
        <DialogTitle> Import / Export </DialogTitle>
        <DialogContent>
          <Button className="button-blue-and-white" onClick={this.exportProducts}>
            <span className="button-text">Export</span>
          </Button>
        </DialogContent>
        <DialogContent>
          <span>
            To import, first download our template and then upload it below. A parent product will
            be created for the following stores.
          </span>
          <br />
          <p>
            <span>
              To import products with stores assigned, enter the shops separated by 2 hyphens in the
              "shops" column of the template.
            </span>
            <br />
            <span>
              Example: <b>Shop1--Shop2--Shop3</b>
            </span>
          </p>
          <p>
            <Button
              variant="text"
              onClick={this.downloadTemplate}
              className="button-white-and-green"
            >
              <span className="button-text">Download Template</span>
            </Button>
          </p>

          <ImageUploaderModal
            modal={false}
            onUpload={this.onUpload}
            onError={this.onError}
            accept="document-csv"
          />
          {file && <span className="center-aligned-child margin">{file.name}</span>}
          {hasError && (
            <span className="center-aligned-child margin text-error">
              Complete the required information
            </span>
          )}
        </DialogContent>
        <DialogActions>
          <div className="container-form-buttons-upload">
            <Button onClick={this.props.closeModal} className="button-white-and-red">
              <span className="button-text">Back</span>
            </Button>
            <Button className="button-blue-and-white" onClick={this.processUploadDocument}>
              <span className="button-text">Upload</span>
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    )
  }
}

export default ModalMcImportProducts



// WEBPACK FOOTER //
// ./src/components/MasterCatalog/Modals/ModalMcImportProducts.js